import 'babel-polyfill'
import Promise from 'promise-polyfill'
import 'form-service/frontend/lib/assets/sass/main.scss'
import config from 'form-service'

if (!window.Promise) {
  window.Promise = Promise
}

if (module.hot) {
  module.hot.accept()
}

if (!process.env.NODE_ENV_SETTINGS) {
  throw new Error('Enviroment variable NODE_ENV_SETTINGS not specified')
}

let formServiceUrl
let OAUTHUrl
let OAUTHRedirectUrl
let PrimaryAuthUrl

// Удалить после первой успешной сборки на develop и на production
console.log('NODE_ENV_SETTINGS', process.env.NODE_ENV_SETTINGS)

if (process.env.NODE_ENV_SETTINGS === 'develop') {
  formServiceUrl = 'https://forms.dev.jlr.perx.ru/forms/api/v1'
  OAUTHUrl = 'https://forms.dev.jlr.perx.ru/auth'
  OAUTHRedirectUrl = 'https://forms.dev.jlr.perx.ru'
  PrimaryAuthUrl = 'http://dev.lr-dealers.ru/forms_service/'
} else {
  formServiceUrl = 'https://forms.jlr-connect.com/forms/api/v1'
  OAUTHUrl = 'https://forms.jlr-connect.com/auth'
  OAUTHRedirectUrl = 'https://forms.jlr-connect.com'
  PrimaryAuthUrl = 'http://master.prod.lr-dealers.ru/forms_service'
}

config({
  appId: 'form-service-admin',
  formServiceUrl,
  statuses: [
    'Выполнен',
    'Отложен',
  ],
  auth: {
    OAUTHUrl,
    OAUTHRedirectUrl,
    OAUTHClientId: 'FormServiceJWTClient',
    OAUTHSecret: 'ZTNiMGM0NDI5OGZjMWMxNDlhZmJmNGM4',
    isImplicit: true,
  },
})



// WEBPACK FOOTER //
// ./index.js